import React, { Component } from "react";
import numeral from "numeral";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./chatclasses.css";
import Skeleton from "react-loading-skeleton";
import { backupImage } from "./backupImage";
import moment from "moment";

class WorkerCard extends Component {
  state = {
    0: false,
    1: false
  };
  getItems = currBucket => {
    //console.log("here is currBucket: " + JSON.stringify(currBucket));
    if (
      currBucket &&
      currBucket.length > 0 &&
      currBucket !== "" &&
      typeof currBucket === "object"
    ) {
      return currBucket.map((product, index) => {
        return (
          <div
            style={{
              border: "1px solid white",
              margin: "0px",
              fontSize: "10px"
            }}
          >
            <div
              style={{
                display: "flex",
                minHeight: "70px",
                alignItems: "center"
              }}
            >
              <LazyLoadImage
                src={
                  product.photos && product.photos.length > 0
                    ? product.photos[0].url
                    : backupImage
                }
                style={{
                  maxWidth: "50px",
                  maxHeight: "50px",
                  height: this.state[0] ? "50px" : "0px",
                  width: this.state[0] ? "50px" : "0px",
                  borderRadius: "50px",
                  border: this.state[0] ? "1px solid gainsboro" : "0px",
                  objectFit: "contain",
                  margin: this.state[0] ? "5px" : "0px",
                  minWidth: this.state[0] ? "50px" : null
                }}
                afterLoad={() => {
                  this.setState(prevState => {
                    return {
                      ...prevState,
                      [0]: true
                    };
                  });
                }}
                onError={() => {
                  let probElem = document.getElementById(
                    "img" + this.props.rec.key + index
                  );
                  if (probElem && probElem !== undefined) {
                    probElem.src = backupImage;
                  }
                }}
                id={"img" + this.props.rec.key + index}
              />
              {!this.state[0] && (
                <Skeleton
                  style={{
                    height: "50px",
                    width: "50px",
                    borderRadius: "50px",
                    border: "1px solid gainsboro",
                    border: "0px solid gainsboro",
                    margin: "5px"
                  }}
                  duration={1}
                />
              )}
              <div
                style={{
                  width: "100%",
                  display: "flex"
                }}
              >
                <table
                  className="table table-lg"
                  style={{
                    margin: "auto"
                  }}
                >
                  <tr>
                    <td>{product.productNameEnglish}</td>
                    <td>
                      <div
                        style={{
                          fontSize: "12px",
                          textAlign: "right",
                          margin: "3px"
                        }}
                      >
                        ${product.amount}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>{product.unit}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>
                      {product.quantity} x {product.productPrice}
                    </td>
                    <td></td>
                  </tr>
                </table>
              </div>
            </div>
            <hr style={{ margin: "0px" }} />
          </div>
        );
      });
    }
  };

  itemUpdateHandler = (rowNum, newVal, recKey) => {
    // console.log(
    //   "rowNum: " + rowNum + " recKey: " + recKey + " newVal: " + newVal
    // );

    let tmpData = _.cloneDeep(this.props.data);
    //console.log("Before: " + JSON.stringify(tmpData[rowNum]));
    if (rowNum !== undefined && isNumber(rowNum)) {
      tmpData["requestedItems"][rowNum][recKey] = newVal;
      let newAmt =
        tmpData["requestedItems"][rowNum]["quantity"] *
        tmpData["requestedItems"][rowNum]["productPrice"];
      //console.log(newAmt);
      newAmt = newAmt.toFixed(2);
      //console.log(newAmt);
      tmpData["requestedItems"][rowNum]["amount"] = "" + newAmt + "";
      //console.log("After: " + JSON.stringify(tmpData[rowNum]));
    } else {
      tmpData[recKey] = newVal;
    }

    this.props.updateRecord({ path: this.props.tableName, payload: tmpData });
  };

  saveHandler = () => {
    if (
      this.state.message &&
      this.state.message.msgText &&
      this.state.message.msgText.length > 0
    ) {
      let data = _.cloneDeep(this.props.rec);
      if (data.messages && data.messages.length > 0) {
        data.messages.push(this.state.message);
      } else {
        data["messages"] = [];
        data.messages.push(this.state.message);
      }
      if (data && data.key && data.key !== "") {
        let cloudPath = this.props.path + "/" + data.key;

        this.props.firebase.db
          .ref("/" + cloudPath)
          .once("value")
          .then(snap => {
            snap.ref.set(data);
            //send only to supplier
            this.props.onNotifyUsers(
              data.name + " says: " + this.refs.searchText.value,
              this.props.allSuppliers,
              false
            );

            this.refs.searchText.value = "";
            return "";
          })
          .catch(err => {
            console.log(err);
            alert("Message could not be sent. " + err);
            return "";
          })
          .then(err => {});

        this.props.firebase.db
          .ref("/myOrders" + "/" + data.mobile + "/" + data.key)
          .once("value")
          .then(snap => {
            return snap.ref.set(data);
          })
          .catch(err => {
            console.log(err);
            alert("Order could not be compeleted. " + err);
            return "";
          })
          .then(err => {
            this.stateChangeHandler(false, "editMode", false);
          });
      }
    }
  };

  getBasicRow = (label, value) => {
    return (
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            marginLeft: "5px",
            marginRight: "5px",
            padding: "5px",
            fontSize: "14px"
          }}
        >
          <div
            style={{
              width: "50%",
              textAlign: "left"
            }}
          >
            {label}
          </div>
          <div
            style={{
              width: "50%",
              textAlign: "right"
            }}
          >
            {value}
          </div>
        </div>
        <hr
          style={{
            margin: "0px"
          }}
        />
      </div>
    );
  };

  getMessages = () => {
    let msgs = this.props.rec.messages;
    if (msgs && msgs.length > 0) {
      return msgs.map(msg => {
        const fromMe = this.props.phoneNumber === msg.author ? "from-me" : "";

        return (
          <div className={`message ${fromMe}`}>
            <div className="username">{msg.author}</div>
            <div className="message-body">{msg.msgText}</div>
          </div>
        );
      });
    }
  };

  getCard = rec => {
    //console.log("in worker card: " + JSON.stringify(rec));
    return (
      <div
        style={{
          borderRadius: "10px",
          backgroundColor: "white",
          margin: "5px",
          padding: "10px",
          marginBottom: "15px",
          fontSize: "12px",
          fontWeight: "bold"
        }}
      >
        {(rec.status === "DELIVERED" || rec.status === "CANCELLED") && (
          <div
            style={{
              color: "#333",
              fontSize: "14px",
              backgroundColor: "rgb(30, 101, 144)",
              padding: "5px",
              borderRadius: "5px",
              fontSize: "18px",
              color: "white"
            }}
            onClick={() => {
              if (rec.status === "DELIVERED" || rec.status !== "CANCELLED") {
                this.props.repeatOrder(rec);
              }
            }}
          >
            <div style={{ textAlign: "center" }}>ORDER SAME ITEMS AGAIN </div>
          </div>
        )}
        {rec.status !== "DELIVERED" &&
          rec.status !== "" &&
          rec.status !== "IN PROGRESS" &&
          rec.status !== "CANCELLED" && (
            <div
              style={{
                color: "#333",
                fontSize: "14px",
                backgroundColor: "rgb(30, 101, 144)",
                padding: "5px",
                borderRadius: "5px",
                fontSize: "18px",
                color: "white"
              }}
              onClick={() => {
                if (
                  rec.status !== "DELIVERED" &&
                  rec.status !== "" &&
                  rec.status !== "IN PROGRESS" &&
                  rec.status !== "CANCELLED"
                ) {
                  this.props.handleEdit(rec.key, this.props.tableName, rec);
                }
              }}
            >
              {rec.status !== "DELIVERED" &&
                rec.status !== "" &&
                rec.status !== "IN PROGRESS" &&
                rec.status !== "CANCELLED" && (
                  <div style={{ textAlign: "center" }}>EDIT ORDER</div>
                )}
            </div>
          )}
        <div
          style={{
            paddingTop: "5px",
            paddingBottom: "5px"
          }}
        >
          {rec.status !== "DELIVERED" &&
            rec.status !== "" &&
            rec.status !== "CANCELLED" && (
              <div>
                Your delivery is getting ready and we will be in contact with
                you shortly. Please contact us at 94562455 for any urgent
                requests.
              </div>
            )}
          {rec.status && rec.status === "DELIVERED" && (
            <div>
              This order has been marked as DELIVERED by {rec.supplier}. For any
              feedback or complaints please contact us at Cell# 94562455. We
              hope you liked this service.
            </div>
          )}
          {rec.status && rec.status === "CANCELLED" && (
            <div>You have cancelled this order. </div>
          )}
        </div>
        <hr
          style={{
            margin: "0px"
          }}
        />
        <div
          style={{
            borderRadius: "5px",
            color: "black",
            backgroundColor: "white",
            fontSize: "18px",
            border: "0px solid rgb(30, 101, 144)",
            cursor: "pointer",
            fontWeight: "bold",
            height: "40px",
            lineHeight: "40px",
            textAlign: "center",
            margin: "5px",
            display: "flex"
          }}
        >
          <div
            style={{
              width: "50%",
              textAlign: "left"
            }}
          >
            <span style={{ fontSize: "10px" }}>Items: </span>{" "}
            {rec.requestedItems && rec.requestedItems.length > 0
              ? rec.requestedItems.length
              : 0}{" "}
          </div>
          <div
            style={{
              width: "50%",
              textAlign: "right"
            }}
          >
            <span style={{ fontSize: "10px", marginLeft: "10px" }}>SGD: </span>{" "}
            {rec.orderTotal}
          </div>
        </div>
        <hr
          style={{
            margin: "0px"
          }}
        />
        {rec.messages && rec.messages.length > 0 && (
          <div
            style={{
              minHeight: "40px",
              padding: "5px"
            }}
          >
            {this.getMessages()}
          </div>
        )}
        {rec.messages && rec.messages.length > 0 && (
          <hr
            style={{
              margin: "0px"
            }}
          />
        )}
        <div
          style={{
            display: "flex",
            direction: "row"
          }}
        >
          <div
            style={{
              width: "100%"
            }}
          >
            <textarea
              type="text"
              placeholder="Enter your message"
              ref="searchText"
              onKeyUp={e => {
                let msgTime = moment()
                  .format("h:mma DD-MM")
                  .toLocaleString();
                this.setState({
                  message: {
                    msgTime: msgTime,
                    author: this.props.phoneNumber,
                    msgText: e.target.value
                  }
                });
              }}
              style={{
                height: "35px",
                borderRadius: "5px",
                width: "100%",
                border: "0px",
                padding: "5px",
                margin: "5px",
                border: "1px solid gainsboro"
              }}
              rows={3}
            />
          </div>
          <div
            onClick={this.saveHandler}
            style={{
              width: "60px",
              margin: "2px",
              textAlign: "center",
              height: "35px",
              /* background-color: blue; */
              lineHeight: "35px",
              border: "1px solid white",
              marginTop: "5px",
              marginBottom: "5px",
              marginLeft: "10px",
              backgroundColor: "rgb(30, 101, 144)",
              color: "white"
            }}
          >
            Send
          </div>
        </div>
        <hr
          style={{
            margin: "0px"
          }}
        />

        {this.getBasicRow("Status", rec.status)}
        {this.getBasicRow(
          "Order Date",
          rec.deliveryDate +
            " " +
            (rec.orderTime && rec.orderTime !== "" ? rec.orderTime : ""),
          "deliveryDate"
        )}
        {this.getBasicRow(
          "Target Delivery Date",
          rec.targetDeliveryDate ? rec.targetDeliveryDate : "-",
          "targetDeliveryDate"
        )}
        {this.getBasicRow("Name", rec.name)}
        {this.getBasicRow("Phone", rec.mobile)}
        {this.getBasicRow("Address", rec.address)}
        {this.getBasicRow("Other Items", rec.otherItems)}
        <hr
          style={{
            margin: "0px"
          }}
        />
        <div>
          {rec.requestedItems &&
            rec.requestedItems.length > 0 &&
            this.getItems(rec.requestedItems)}
        </div>
      </div>
    );
  };
  render() {
    return <div>{this.getCard(this.props.rec)}</div>;
  }
}

export default WorkerCard;



// WEBPACK FOOTER //
// ./src/app/components/Screens/ContentGrid/WorkerCard.jsx